<template>
  <div class="pb-qdb">
    <div class="pb-qdb__center">
      钱袋宝支付服务协议
    </div>
    <div>甲方：<span>{{ qualificationName }}</span></div>
    <p>乙方：{{ qdbName }}</p>
    <p>联系地址：北京市海淀区羊坊店路18号2幢12层1224-1</p>
    <p>甲、乙双方本着平等、互利、友好协商的原则，就甲方使用乙方网络支付服务等相关事宜达成一致，签订本协议，以资共同遵守。 </p>

    <p class="pb-qdb__bold">
      一、定义
    </p>
    <ol>
      <li>支付平台：指乙方自行建设的以进行支付交易为主要目的的业务系统，以甲方通过支付接口发来的付款指令为依据，为甲方业务提供交易认证和款项收付等支付服务的系统。</li>
      <li>支付服务：是指乙方通过支付平台向甲方提供的支付软件系统、支付服务及其他相关服务。甲方委托乙方进行款项收付与资金结算服务。</li>
      <li>支付账户：指甲方通过钱袋宝身份验证并同意本协议后取得的甲方使用钱袋宝服务的支付账户。除本协议另有约定外，钱袋宝账户持有人可以使用与支付相关的服务。</li>
      <li>有权机关：指依照法律法规等有权要求采取查询、冻结或扣划资金等措施的单位，包括但不限于公安机关、检察院、法院、海关、税务机关等。</li>
      <li>有权机关冻结：指按照前述有权机关要求进行的冻结。被冻结余额不能用于支付、提现或转账等，被冻结账户可能无法登录、使用。</li>
      <li>限制：指除有权机关冻结情况之外，钱袋宝账号或支付账户部分或全部功能不能使用，以及账号或支付账户相关资产、账户余额、第三方提供的授信额度不能使用。</li>
    </ol>
    <p class="pb-qdb__bold">
      二、合作内容
    </p>
    <ol>
      <li>开户，开立钱袋宝支付账户，甲方可根据实际需求，在乙方开立一个或多个支付账户。</li>
      <li>充值，甲方可以将甲方银行卡内的资金充值到甲方的钱袋宝账户。</li>
      <li>提现，甲方可以将甲方钱袋宝账户内余额划转至甲方名下的可接收款项的中国大陆银行账户。</li>
      <li>在线查询服务：乙方为甲方设立支付平台查询功能，为甲方提供信息管理和交易信息查询服务。</li>
      <li>其他支付产品：如甲方需要其他的支付产品的需求，以双方签署产品协议或甲方在乙方系统中选择开通相应的产品为准。</li>
    </ol>
    <p class="pb-qdb__bold">
      三、甲方权利和义务
    </p>
    <ol>
      <li>甲方应如实向乙方提供资质资料，包括但不限于营业执照、开户许可证、法定代表人身份证复印件、ICP经营许可证或备案记录（如有）、公司业务介绍及基本业务情况说明、企业邮箱（非个人E-mail信箱）等。甲方保证上述资料合法、真实、准确、完整。</li>
      <li>甲方不得把支付账户（如有）、乙方提供的接口技术、安全协议及证书用于本协议范围以外的用途，也不得出租、转让给任何第三方使用。甲方不得将其他商户的交易伪造成自己的交易与乙方结算。如果甲方违反前述规定出租、出借、出售、购买账户的，乙方可在发生前述情况的5年内不向甲方提供支付账户所有业务。</li>
      <li>甲方不得存储包括用户银行卡的磁道信息或芯片信息、验证码、密码、银行卡有效期在内的任何敏感信息，不得泄露用户身份信息和账户信息等。</li>
      <li>甲方应妥善保管甲方商户号、密码等信息。因甲方未进行妥善保管造成甲方资金损失的，乙方不承担任何责任。若甲方需对支付账户进行挂失，应及时与乙方客服人员联系，并按相关要求进行操作。</li>
      <li>甲方应妥善保管在乙方开立支付账户预留的手机号，此手机号的用途为账户登录、接收支付账户短信通知、身份验证等。甲方不得把手机号验证码信息提供给第三方操作认证，因甲方未进行妥善保管造成甲方资金损失的，乙方不承担任何责任。若甲方需对支付账户预留手机号进行变更，应至乙方支付平台中进行操作，或与乙方商服人员联系，并相关要求操作手机号变更。</li>
      <li>甲方使用乙方支付服务时，应确保自身发出指令的合法性、真实性、有效性和完整性。乙方按甲方发起的指令完成操作后，相关资金风险和责任由甲方承担。 </li>
      <li>甲方应承诺发起的交易基于真实的交易背景，甲方应保证其与甲方客户之间交易的真实性、合法性，不得利用乙方提供的服务进行虚假交易。甲方应按乙方的要求向乙方提供详细的、真实可信的交易信息字段，交易信息至少包括：直接提供商品或服务的商户名称、商品订单号、商品名称、商品描述、交易金额、交易时间和地点、交易类型和渠道等。 </li>
      <li>甲方不得利用乙方的支付服务从事任何非法行为，不得违反中国法律、法规、规章、规范性文件及政策，不得侵犯他人的合法权益，不得实施任何违反公序良俗和诚实信用的行为。如甲方是中国大陆地区以外的特约商户，还需同时遵守其所属国家或地区的法律。 </li>
      <li>甲方不得对乙方所有的包括不限于钱袋宝软件系统、程序采取反向工程手段进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、软件文档、运行在本地电脑内存中的数据、客户端至服务器端的数据、服务器数据等）进行复制、修改、编译、整合和篡改，不得修改或增加乙方提供的钱袋宝软件系统的原有功能。</li>
      <li>甲方核对汇总明细，对账单发现不符情况的，应及时向乙方反馈。乙方应设专门的岗位接受反馈，分析差错原因，并根据情况进行差错处理。 </li>
      <li>甲方应妥善保管交易产生的资料、数据，自交易完成之日起不少于五年。如因甲方保管不善或其他违约行为造成的相关资金风险和责任由甲方承担。如发生用户否认交易或拒付、监管机构的检查或法律法规要求提供的其他情形，甲方应积极协助乙方提供相关交易记录或凭证，自乙方通知之日起7个工作日内提供。 </li>
      <li>甲方保证具有履行本协议的合法资格或资质，不得将乙方提供的网络支付服务用于超出甲方营业执照记载的经营范围的业务。甲方为客户提供甲方的客户服务电话，不得将乙方的客户服务电话作为甲方的客户服务电话发布在甲方网站上误导消费者。</li>
      <li>甲方发布的所有信息及从事的商业活动必须严格遵守国内现行法律法规、政府及工商管理部门的有关规定，并承担与此相应的责任。甲方须独立承担因其网站信息虚假、陈旧、错误或不详实造成的投诉、退货、纠纷等责任。</li>
      <li>甲方应按照乙方提供的支付接口规范完成系统开发改造，实现与乙方的系统对接，并完成相关的系统测试和系统投产准备工作，费用由甲方自行承担。甲方不得将乙方向其收取的网络支付服务费用转嫁给用户。 </li>
      <li>甲方同意乙方有权依据相关法律法规，按照监管部门/乙方合作银行的要求，将其相关交易信息提供给监管部门/乙方合作银行进行核查。</li>
      <li>甲方使用本协议项下乙方提供的相关服务时，应确保甲方的订单处理、提供服务的程序与乙方支付平台结算流程相匹配。</li>
      <li>未经乙方书面授权，甲方不得在多个域名或不同的网站上使用同一甲方商户号的支付接口，不得把乙方提供的接口技术、安全协议及证书等转交其它网站或第三方使用。</li>
      <li>甲方如遇迁址、停业、域名或联系电话等商户资料信息变更，应提前通知乙方，乙方有权视具体情况暂停服务，若由于甲方未及时通知而导致乙方损失的，甲方应承担责任。</li>
      <li>甲方不得进行直接或变相套现、洗钱等违法违规行为，积极配合乙方开展涉及公安等司法机构、人民银行反洗钱等监管机构的交易协查，有义务按要求提供相关交易信息，并且提供协助。</li>
      <li>甲方不得采用技术手段或其它非法手段截获客户的相关信息并引导客户进行支付。甲方不得采取任何方式，违规截取、留存或篡改甲方客户或其他第三方使用乙方支付业务服务的任何信息（包括但不限于用户信息、银行卡信息、充值卡信息等），不得在违背客户意愿的情况下代用户、客户或合作伙伴提交订单或发出虚假指令。否则，甲方应独自承担由此引起的一切法律责任和后果。</li>
      <li>甲方不得将本协议与本协议附件及各补充协议所约定服务用于除约定业务外的其它用途或通过任何方式转移给第三方。否则乙方有权立即停止向甲方提供相关服务，同时甲方需赔偿由此给乙方所造成的全部损失。</li>
      <li>甲方应独立对使用本服务进行资金转移行为承担法律责任。甲方应及时有效地处理其与用户、客户或合作伙伴等的之间发生的各种投诉、矛盾或纠纷。</li>
      <li>甲方应承担甲方平台发生的套现、欺诈、洗钱以及发卡机构合理拒付（包括但不限于持卡人否认交易）的交易风险及由此产生的损失和责任。因以上情形给乙方造成损失的，甲方需赔偿乙方损失。甲方如拖延、拒绝赔偿，乙方有权直接从甲方风险保证金或甲方钱袋宝账户余额中进行赔偿。</li>
      <li>甲方业务变更或终止应提前一个月书面通知乙方，甲方名称、地址、联系方式等甲方相关信息变更应向乙方提出书面或邮件申请，否则甲方须承担由此造成的一切责任和后果。</li>
    </ol>
    <p class="pb-qdb__bold">
      四、乙方权利和义务
    </p>
    <ol>
      <li>乙方负责钱袋宝支付平台的建设、运行和管理。钱袋宝支付平台的管理规则和功能乙方可根据需要制定、修改上述管理规则和功能并进行公告。若甲方不同意乙方修改或制定的内容，应立即书面或邮件告知乙方并同时停止使用乙方提供的相关服务，双方办理解除本协议的相关手续；若甲方继续使用乙方提供的相关服务，则视为甲方确认并承诺遵守乙方制定或修改的管理规则和功能。</li>
      <li>乙方对甲方身份资料及支付信息负有保密义务，不得利用甲方的上述信息从事超出法律许可或未经甲方授权的活动。</li>
      <li>乙方应为甲方提供本协议约定的各项网络支付服务，并可按照约定向甲方收取相关服务费用。 </li>
      <li>乙方应以明确的格式、内容、语言，对其提供的支付产品或服务依法向甲方进行全面、充分的信息披露和风险提示。</li>
      <li>乙方应确保甲方交易资金的安全存放和准确及时划转。 </li>
      <li>甲方故意诋毁或非法损害乙方声誉的，乙方可立即终止提供支付服务，并追偿损失。</li>
      <li>乙方可拒绝支付或追索甲方违反国家法律法规或本协议约定的有关款项。</li>
      <li>乙方应负责受理涉及钱袋宝支付平台、支付结算系统出现问题的投诉并解决相应的纠纷。甲方理解并同意，乙方作为支付机构，仅为甲方提供本协议下的相关网络支付服务，甲方与甲方客户或其他任何第三方之间因网上交易可能发生的其他包括但不限于商品或服务质量、数量等纠纷，与乙方无关。</li>
      <li>乙方应设立业务咨询和联系电话，负责解答甲方在使用乙方支付平台中的遇到的各种疑问，并及时处理双方在数据对账、资金结算过程中的有关问题。</li>
      <li>乙方应向甲方提供履行本协议所需的相关接口技术、文档等资料并提供必要的指导。</li>
      <li>在甲方未全面履行应尽义务且甲方因业务或联络方式变更、终止而未及时通知乙方致使乙方十个工作日内联络甲方未获回应的情况下，对于甲方客户已支付但尚未结算给甲方的订单款项，乙方可根据甲方客户提出的退款请求直接转回甲方客户的账户。</li>
      <li>乙方不得对甲方经营的计算机系统和程序采取反向工程手段进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、软件文档、运行在本地电脑内存中的数据、客户端至服务器端的数据、服务器数据等）进行复制、修改、编译、整合和篡改。</li>
      <li>甲方使用本服务，无论本协议是否有相反约定，即视为甲方授权乙方、乙方关联方以及乙方或乙方关联方的合作方收集并合理使用甲方在使用本服务过程中产生的所有相关信息和数据，包括但不限于甲方的主体信息、账户信息（如财务数据、余额等）和交易信息等，乙方有权将该信息和数据用于拓展业务、改善产品，从而更好地提供服务。但经过处理无法识别甲方特定信息且不能复原的，乙方无需甲方授权。</li>
      <li>甲方连续九十个自然日未使用乙方服务产生交易额的，乙方有权暂停、中止或终止本协议项下的服务而无需承担任何法律责任。如甲方需继续使用，可向乙方重新申请开通，经乙方审核通过后方可。</li>
      <li>甲方或甲方客户/合作方在使用乙方服务过程中非因乙方原因被甲方客户/合作方或其他有关方投诉的，乙方有权要求甲方和客户/合作方及时妥善解决或采取完善补救措施，甲方或客户/合作方未能及时完善或补救的，乙方有权视实际情况中止提供支付服务。乙方投诉电话为支付平台中展示的电话号码。</li>
      <li>基于风险管理、运营管理或其他风险防控因素的考虑，乙方有权提前十个工作日以书面形式告知甲方暂停、中止或终止向甲方提供本协议项下的服务无需承担任何法律责任。</li>
      <li>乙方发布的所有信息及从事的商业活动必须严格遵守国内现行法律法规、政府及工商管理部门的有关规定，并承担与此相应的责任。乙方须独立承担因其网站信息虚假、陈旧、错误或不详实造成的投诉与纠纷。</li>
      <li>乙方仅向甲方和甲方客户/合作方提供电子支付中介服务，并不作为买方或卖方参与到甲方与甲方客户/合作方之间的交易，并不对该交易中甲方提供的服务或产品的质量、安全及合法性和甲方客户/合作方付款等承担任何个别或连带的担保、保证、赔偿责任或义务；甲方客户/合作方向乙方投诉甲方并要求退款，乙方联系甲方30天后，在甲方仍无回应的情况下，乙方有权从甲方未结算款中扣取相应金额返回给甲方客户/合作方。</li>
      <li>乙方保留对可疑交易、非法交易、高风险交易或交易纠纷开展调查、独立判断和确定的权利，并有权要求甲方提供其交易相关的业务单据。</li>
      <li>当乙方以向甲方预留电子信箱发送电子邮件方式向甲方确认有关业务时，发送成功既视为甲方已收到，如需要甲方回复的，甲方应在收到电子邮件后一个工作日内确认并回复；如无需回复，甲方在一个工作日内无其他意思表示的，视为甲方知悉并认可电子邮件所表示内容。双方签订的一切协议、附件及补充协议等，均应以正式书面文件原件确认。</li>
    </ol>
    <p class="pb-qdb__bold">
      五、支付账户开立
    </p>
    <p>乙方可根据甲方需要及《非银行支付机构网络支付业务管理办法》等法律法规的相关要求，为甲方开立支付账户，并提供相关必要的信息查询、技术支持等服务，具体以乙方实际提供的为准。主要流程包括： </p>
    <ol>
      <li>甲方在乙方支付平台如实填写、提供身份基本信息。</li>
      <li>本协议产品协议、附件为本协议组成部分。附件一《商户申请信息资料》作为甲方在乙方开立支付账户所需的信息依据，甲方必须如实填写，并提供相应资质。若甲方信息变更项符合附件二《商户信息变更申请表》所列信息时，甲方按照附件二填写《商户信息变更申请表》并加盖公章后，乙方按照变更申请进行操作。变更成功后，乙方向甲方发送变更成功通知。乙方发送变更成功通知前甲方其支付账户若造成甲方损失的，乙方不承担任何责任。甲方若通过系统变更《商户申请信息资料》信息的，甲方应保证变更操作是甲方真实意思的表示，并对变更后信息产生的后果承担全部责任。</li>
      <li>乙方按照实名制管理要求，登记并采取有效措施验证甲方身份信息，按照规定核对有效身份证件并留存有效身份证件复印件或者影印件，建立甲方唯一识别编码，确保有效核实甲方身份及其真实意愿后，为其开立支付账户。如甲方为从事电子商务经营活动、不具备工商登记注册条件且相关法律法规允许不进行工商登记注册的个人客户，并且不符合《非银行支付机构网络支付业务管理办法》关于支付机构参照单位客户管理的个人卖家的条件要求，乙方应依据身份核验方式的不同为甲方开立相应余额付款功能的支付账户。 </li>
    </ol>
    <p class="pb-qdb__bold">
      六、手续费用及结算
    </p>
    <ol>
      <li>
        钱袋宝支付平台使用手续费：
        <p>(1)甲方使用乙方服务，甲方同意按照乙方标准支付手续费(以下简称“手续费”)。乙方将从甲方发出指令要求乙方提供支付服务的款项中实时扣除手续费，现阶段针对【充电宝合作项目】向甲方提供优惠政策，暂定手续费为0。后续根据运营情况及市场情况，另行调整手续费，届时双方签署补充协议。</p>
        <p>(2)乙方可因国家行政管理部门、中国人民银行、合作机构相关政策调整等情况调整手续费费率或因甲方选择使用乙方其他支付产品而收取手续费。乙方将对此进行通知，如甲方在收费规则生效之前未予以答复的将视为甲方接受该调整，乙方将按照通知公布的收费时间执行新的收费标准。如果甲方在上述期限内提交了书面异议，那么甲方和乙方应对调整后的费率进行友好磋商，如果双方无法就费率变更达成一致意见的，任一方可终止本协议。</p>
      </li>
      <li>
        结算说明
        <p>(1)甲方的交易结算账号为甲方申请本服务时提交的同名银行账号、或甲方自行绑定的开户银行账户或甲方通过附件二变更的开户银行账户（以乙方系统届时保存的银行账户为准），若因甲方或银行的原因导致交易款项无法按时结算至甲方提交的银行账号的，乙方不承担任何责任。</p>
        <p>(2)甲方收取结算款的银行账户：以甲方自行绑定的开户银行账户为准。如甲方不能通过前述方式变更结算银行账户的，甲方应通过附件二向乙方提交申请。</p>
        <p>(3)因甲方变更账号但未及时通知乙方导致增加的额外成本或任何损失，由甲方承担。</p>
        <p>(4)乙方在扣除支付手续费后，将剩余交易款转入甲方在乙方开立的账号。交易款划付至甲方在乙方开立的账户周期以甲方选择的产品为准。乙方有权根据经营需要或甲方/商户的经营状况、业务变化及实际赔付情况调整结算周期及结算转账起点，并以电子邮件通知的方式通知甲方。</p>
        <p>(5)乙方与甲方对账数据不一致的，以乙方数据为准。</p>
        <p>(6)若甲方要求乙方开具发票，应在首次开票前按照乙方要求及时提交准确、完整的发票信息，当月的手续费发票在下月开出；如需增值税专用发票，甲方应提交一般纳税人资质材料。</p>
      </li>
    </ol>
    <p class="pb-qdb__bold">
      七、退款条款
    </p>
    <p>如在交易中出现的因甲方原因造成需做退款处理的情况，按如下规则处理：</p>
    <ol>
      <li>当甲方向乙方提出退款请求时，甲方应保证自己账户中有足够退款的账存资金（被冻结或被限制的款项除外），乙方有权直接从甲方账户中扣除退款金额完成退款，如因甲方账户余额不足导致无法退款的，其后果由甲方自行承担。乙方按甲方退款请求处理退款时，如因甲方原因或用户原因导致退款失败的，乙方将退款金额退甲方账户，甲方可再次发起退款请求或自行处理退款。</li>
      <li>退款时，乙方不再另收取手续费，但若银行方面需要向乙方另行收取相关费用的，则此费用应由甲方自行承担，乙方可从甲方的交易款中扣除。</li>
      <li>发生退款情况，乙方不再就该笔退款收取手续费，但乙方也不再退还该笔交易已发生的手续费。</li>
    </ol>
    <p class="pb-qdb__bold">
      八、交易限额
    </p>
    <p>依据双方合作业务类型以及风险不同而设定的交易限制额度：</p>
    <ol>
      <li>单笔最高限额：甲方根据自身业务需要提出，并由乙方或银行、银联等机构风险控制部门最终审核确定的单次扣款最高限制金额。</li>
      <li>单日最高限额：甲方根据自身业务需要提出，并由乙方或银行、银联等风险控制部门最终审核确定的甲方单日扣款最高限制金额。</li>
      <li>为防范盗卡及拒付等风险，保护甲方、乙方、持卡人、银行的共同利益，乙方将根据甲方的交易情况（例如发生盗卡或拒付等风险交易所占的比例）、保证金的缴纳情况等对甲方客户通过特定支付服务向甲方付款的单笔额度和单日额度设定限额，并有权随时根据情况对限额作出调整。乙方调整限额时，将提前通知甲方。</li>
    </ol>
    <p class="pb-qdb__bold">
      九、调单、先行赔付及风险处理
    </p>
    <ol>
      <li>
        若出现下列情形之一的，乙方有权调单，即要求甲方提供其交易的有效单据，包括但不限于发收货证明、发票等，甲方应予配合。
        <p>(1)银行、有权机关、乙方发现甲方交易出现异常状况或存在可疑风险交易的；</p>
        <p>(2)甲方客户投诉、拒付、要求赔偿的。</p>
      </li>
      <li>若乙方、银行或有权机关发现甲方某个时间段交易出现异常状况或存在可疑风险交易，乙方有权立即暂缓相关交易款项的结算工作，并以电子邮件、传真或其他形式通知甲方对该笔交易进行风险调单，甲方需按要求提供真实有效的相关交易证据，待乙方、银行或有权机关核准后由乙方为其结算。</li>
      <li>甲方若发生某笔交易被调单情形，则甲方钱袋宝账户中的该笔/相应资金将由乙方先行暂缓支付。经银行审查甲方提交的资料后，认为甲方应当赔付的，甲方应当无条件全额对持卡人或银行或乙方进行赔付，经审查后认为不需要赔付的，乙方及时对甲方钱袋宝账户中的该笔/相应资金进行解冻以及结算工作。</li>
      <li>若乙方收到银行或有权机构方面的赔付通知，乙方有权自收到赔付通知后即刻从甲方的钱袋宝账户中等额扣除赔付款项，按照银行或有权机构要求进行偿还。若甲方钱袋宝账户的余额不足，乙方有权以甲方预先支付的保证金作进行抵扣。在抵扣保证金仍不足以清偿赔付款的情况下，乙方保留继续追偿的权利；在甲方未能偿还赔付款项或保证金未补足时，乙方有权暂时中止向甲方提供相应服务，直至甲方全部偿还赔付款项并补齐保证金为止。</li>
      <li>乙方从甲方钱袋宝账户中扣除赔付款项或保证金，应将银行的赔付通知等相关材料以本协议附表一所列明甲方的Email或传真等方式及时通知甲方。</li>
      <li>甲方在收到乙方的扣款通知后，对赔付有异议的，可直接与用户及银行联系，乙方不处理关于赔付异议的任何纠纷。</li>
      <li>乙方收到银行的相应赔付通知后，有权根据甲方的风险评估状况，决定是否中止或终止向甲方提供相应服务。</li>
      <li>针对甲方将乙方所提供的服务应用于本协议约定业务范围之外而产生的交易导致持卡用户拒付，甲方均应当无条件全额对持卡人或银行或乙方进行赔付。</li>
      <li>若甲方的月风险交易笔数超过3笔或月风险交易金额超过1万元，则乙方有权单方终止本协议。</li>
    </ol>
    <p class="pb-qdb__bold">
      十、知识产权
    </p>
    <ol>
      <li>甲方拥有其网站平台及相关系统、程序、产品和服务的一切权利，包括但不限于：文字、软件、声音、图片、录像、图表、广告中的全部内容、电子邮件的全部内容、甲方网站为用户提供的其他信息等，所有上述内容均受法律的保护。</li>
      <li>乙方拥有钱袋宝支付平台及相关系统、程序、产品和服务的一切权利，包括但不限于：文字、软件、声音、图片、录像、图表、广告中的全部内容、钱袋宝电子邮件的全部内容、乙方网站为用户提供的其他信息等，所有上述内容均受法律的保护。</li>
      <li>甲方因履行本协议需要使用以上权利的，应经乙方书面许可。乙方的书面许可不构成任何形式的权利转让。</li>
      <li>本协议终止后，前两款约定仍然有效。</li>
    </ol>
    <p class="pb-qdb__bold">
      十一、保密义务
    </p>
    <ol>
      <li>除本协议另有约定外，未经一方书面同意，另一方不得将本协议内容、客户个人信息、客户支付信息以及一方提供给另一方的接口技术、安全协议及证书等透露给第三方。</li>
      <li>甲、乙双方对在履行协议中获得的对方商业机密和技术秘密均负有保密责任。</li>
      <li>甲、乙双方保证其雇员及代理人履行本条的保密义务。</li>
      <li>
        本合同任何一方均应对所获得的另一方的保密资料实施必要的安全保护措施，保护措施应当至少涵盖以下要求：
        <p>(1)对于保密资料的访问应当充分做好访问控制（包括技术层面、物理层面），仅限于授权的相关人员或者相关应用进行访问。</p>
        <p>(2)禁止在第三方信息平台（如网盘、网站、博客等提供信息存储的平台）公开存储或处理对方的保密资料。</p>
        <p>(3)应当确保用于存储保密资料的技术平台安全性（包括网站、应用系统、操作系统、服务器、数据库等）。</p>
        <p>(4)应当对指定保密信息（如用户信息等）的传输和存储实施满足国家及监管要求的加密安全措施。</p>
      </li>
      <li>本合同任何一方如发现对方存在涉及保密资料保护措施缺失、数据滥用、严重泄露等问题，发现方有权按照本协议相关条款进行处理，并且对于已产生的实际损失和不良影响，由对方全责承担。</li>
      <li>上述保密义务在本协议终止后仍然有效。</li>
    </ol>
    <p class="pb-qdb__bold">
      十二、不可抗力及免责事由
    </p>
    <ol>
      <li>
        因受不可抗力影响而不能履行或不能完全履行本协议的一方可以部分或全部免除履行其责任。 不可抗力是指不能预见、对其发生和后果不能避免且不能克服的事件。鉴于网络所具有之特殊性质，发生包括但不限于下列任何影响网络正常经营之情形导致乙方不能履行本协议下义务的，乙方可以免责：
        <p>(1)大规模黑客攻击、计算机病毒侵入或发作；</p>
        <p>(2)非乙方过错造成的计算机系统遭到破坏、瘫痪或无法正常使用的；</p>
        <p>(3)电信部门技术调整导致之重大影响；</p>
        <p>(4)因政府管制而造成的暂时性关闭等；</p>
        <p>(5)其它非乙方过错造成的原因等。</p>
      </li>
      <li>遇有上述不可抗力事件的一方，应立即将事件情况书面或电子邮件通知对方，并应于十五个工作日内通告事件详情，并提供相关证明材料以说明不能履行或不能完全履行、或需要延期履行的理由。双方按照事件对协议的履行的影响程度，再行决定是否继续履行本协议或终止协议。</li>
    </ol>
    <p class="pb-qdb__bold">
      十三、风险提示及特别约定
    </p>
    <ol>
      <li>双方对于“中国国内电子商务环境尚未成熟，电子商务立法以及信用体制还不完善”的现状以及开展电子商务业务存在的风险性均完全知悉，双方均承诺采取相关风险防范措施，以尽量避免或减小风险。</li>
      <li>在网上支付交易中，遇到网上交易不真实、欺诈、冒用、持卡人拒付（Chargeback）由相关责任人自行解决，乙方应提供必要配合，若由于甲方错误造成的风险，由甲方自行解决并担责。</li>
      <li>甲方在使用乙方进行支付交易过程中，遵守中国人民银行网上银行业务和信用卡相关交易相关的政策法规，不得进行虚假交易、资金非法套现、洗钱等非法行为。</li>
      <li>乙方提示您注意，乙方账户所记录的资金余额不同于甲方的银行存款，不受《存款保险条例》保护，其实质为甲方委托乙方保管的、所有权归属于甲方的预付价值。该预付价值对应的货币资金虽然属于甲方，但不以甲方名义存放在银行，而是以乙方名义存放在银行，并且由乙方向银行发起资金调拨指令。</li>
    </ol>
    <p class="pb-qdb__bold">
      十四、反洗钱
    </p>
    <ol class="pb-qdb__bold">
      <li>双方应按照《中华人民共和国反洗钱法》和《金融机构客户身份识别和客户身份资料及交易记录保存管理办法》、《支付机构反洗钱和反恐怖融资管理办法》等有关反洗钱的法律法规和双方协议约定履行反洗钱义务，并互相为对方在开展反洗钱工作上提供充分的协助。</li>
      <li>甲方应保证资金来源合法，并保证使用钱袋宝提供的支付服务进行的交易真实合法。</li>
    </ol>
    <p class="pb-qdb__bold">
      十五、违约责任
    </p>
    <ol>
      <li>甲、乙双方中的任何一方违反在本协议中的义务、所做保证、承诺或其他约定，均构成违约，应承担由此产生的全部责任。</li>
      <li>甲方违反本协议约定时，乙方有权暂时停止为甲方提供服务或采取其他保全措施。甲方纠正其违约行为并承担相应违约责任后，乙方应及时为甲方恢复开通服务、解除相关保全措施。甲方拒不承担违约责任的，甲方同意乙方有权从交易款中直接扣减相应金额用于赔偿乙方损失。</li>
      <li>乙方对甲方在本协议项下的任何违约或延误行为施以宽容、宽限或延缓执行其享有的权利，均不能损害、影响或限制乙方依本协议和有关法律规定应享有的一切权益、权利，不能视为乙方放弃对现有或将来违约行为采取行动的权利。</li>
      <li>甲方应向乙方承担赔偿责任的，甲方须在收到乙方通知后五个工作日内向乙方赔偿由于甲方违约导致的乙方所有损失，否则乙方有权直接自甲方名下的支付账户中扣取，若甲方名下的支付账户余额不足时，甲方应在五日内（含五日）向其钱袋宝支付账户充值并授权乙方直接自账户余额中扣取直至赔付完毕；如甲方在五日后仍未能足额向乙方清偿的，乙方有权终止甲乙双方签署的所有协议。</li>
    </ol>
    <p class="pb-qdb__bold">
      十六、协议解除
    </p>
    <ol>
      <li>
        一方发生下列情形之一的，另一方可以立即解除本协议：
        <p>(1)甲方或乙方未履行相关义务导致本协议不能实际履行；</p>
        <p>(2)一方被吊销营业执照，或因任何原因进入破产清算、和解或重整程序。</p>
      </li>
      <li>
        发生下列情形之一的，乙方可以暂停服务或解除本协议，并要求甲方承担法律责任：
        <p>(1)甲方将乙方的客户服务电话作为甲方的客户服务电话发布在甲方网站上的；</p>
        <p>(2)甲方未经乙方书面同意，擅自将乙方提供的接口技术、安全协议及证书等转交其它网站或第三方使用的；</p>
        <p>(3)甲方未按本协议向乙方支付相关费用；</p>
        <p>(4)甲方违反本协议中所做的承诺与保证的；</p>
        <p>(5)甲方利用乙方提供的服务从事非法活动的；</p>
        <p>(6)甲方有其他违反本协议约定的行为，且在收到乙方通知后两个工作日内，甲方仍未采取措施纠正的。</p>
      </li>
    </ol>
    <p class="pb-qdb__bold">
      十七、争议解决和法律适用
    </p>
    <p>甲、乙双方应以友好协商方式解决本协议履行过程中产生的争议，经协商无法解决争议时，提请协议被告住所地人民法院诉讼解决。本协议适用中华人民共和国法律。</p>
    <p class="pb-qdb__bold">
      十八、其他条款
    </p>
    <ol>
      <li>本协议自双方签字、盖章之日起生效；乙方向甲方提供服务之日早于协议生效日的，自乙方向甲方提供服务之日起生效，有效期为一年。如本协议首次和后续历次有效期届满前的一个月内甲、乙双方均未提出书面要求终止协议的，本协议应视为自动延期一年，以此类推。本协议一式贰份，双方各执壹份，具有同等法律效力。</li>
      <li>除非各方另有约定，本协议项下的所有通知应通过快递服务或电子邮箱传送。各方之间的通知及往来信函应发送至本协议载明的地址或电子邮箱(或收件人提前七个自然日向其他方发出书面通知说明的其他地址或电子邮箱) 。</li>
      <li>乙方为甲方提供支付服务，并可能根据实际情况签署单独的产品协议或其他协议（“产品协议”）或乙方系统中选择开通相应的产品，遵守产品协议的有关约定。产品协议、收费规则等通知均为本协议的有效部分，与本协议具有同等效力。本协议与产品协议有冲突的，以产品协议为准。</li>
      <li>身份验证：为了向甲方提供更好的服务，乙方将及时有效验证甲方及甲方委托签约人的个人信息。根据法律法规及监管规定或钱袋宝认为有需要时，甲方同意并授权乙方可以把甲方及甲方委托签约人的个人的信息提供给第三方，也同意第三方可以把甲方的信息提供给乙方，以便乙方进行验证。甲方应确保钱袋宝登录名、账号或支付账户绑定的电子邮箱或手机号均为甲方持有或得到甲方授权。</li>
    </ol>
    <p class="pb-qdb__bold">
      甲方声明： 乙方已提请我方注意对本协议各条款，特别是黑体字条款作全面、准确的理解，并应我方要求作了相应条款的说明。签约各方对本协议的含义认识一致，认同并接受本协议全部条款。
    </p>
    <p class="pb-qdb__bold">
      本单位充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒措施，承诺依法依规开立和使用本单位账户。
    </p>
    <p>（以下无正文）</p>
    <div><span>甲方（商户盖章处）：  {{ qualificationName }} </span></div>
    <div><span>乙方（钱袋宝盖章处）： {{ qdbName }}</span></div>
    <div>盖章日期：       {{ signDate }}</div>
    <p class="pb-qdb__center pb-qdb__bold">
      个人/单位在支付机构开设支付结算账户
    </p>
    <p class="pb-qdb__center pb-qdb__bold">
      涉电网络新型违法犯罪法律责任及防范提示告知书
    </p>
    <p>为加强支付结算账户(以下简称“账户”)的规范管理，避免个人或单位（《钱袋宝支付服务协议》甲方，以下简称“甲方”）在支付机构开设账户被违法犯罪人员用于实施电信网络新型违法犯罪活动，特将相关法律责任及防范提示告知如下:</p>
    <div>一、甲方明知他人实施电信网络骗犯，<span class="pb-qdb__under-line pb-qdb__bold">仍以出售、出租、出借、转让等方式非法提供本人(本单位)支付账户供他人使用的，</span>依照《关于办理电信网络许骗等刑事件适用法律若干问题的意见》(法发(2016)32号)第四条第三款之规定，以电信网诈骗共同犯罪追究刑事责任。</div>
    <div>二、甲方应当妥善保管本人（本单位）名下支付账户，<span class="pb-qdb__under-line pb-qdb__bold">严禁以出售、出租、出借、转让方式非法提供本人（本单位）支付账户供他人使用。</span>甲方实施上述禁止行为且该账户被查实用于实施电信网络诈骗等犯罪活动的，依照《中华人民共和国刑法》第二百十七条之二规定，以帮助信息网犯活动追究刑事责任。</div>
    <div>三、根据中国人民银行《关于进一步加强支付结算管理防电信网络新型违法犯罪有关事项的通知》(银发(2019)85号)第二条第九款之规定，<span class="pb-qdb__under-line pb-qdb__bold">可以对涉嫌电信网络新型违法犯罪的账户及其所有人成所属单位实施惩戒，5年内暂停涉案账户非柜面业务、支付账户所有业务，并不得为其新开立账户，并将涉案账户的个人和单位信息移送金融信息基础数据库并向社会公布。</span></div>
    <div>四、本告知书与《钱袋宝支付服务协议》共同构成一份完整的法律文件，具有同等法律效力。</div>
    <p><span class="pb-qdb__under-line pb-qdb__bold">甲方声明：本人（本单位）已清楚并知晓上述告知内容及相应法律责任，承诺不参与电信网络违法犯罪行为，依法开设、使用本人（本单位)支付账户，绝不非法向他人出售、出租、或转让支付结算账户。</span></p>
    <p>甲方（商户盖章处）： {{ qualificationName }}</p>
    <p>日期：       {{ signDate }}</p>
  </div>
</template>

<script>
import createWalletApi from '@/api/createWallet';
import STATUS from '@/constants/status';

export default {
  name: 'QdbAgreement',
  data() {
    return {
      qualificationName: '',
      qdbName: '北京钱袋宝支付技术有限公司',
      signDate: '',
    };
  },
  created() {
    this.getNameAndDate();
  },
  methods: {
    async getNameAndDate() {
      try {
        const partnerId = this.$store.getters['partnerModule/id'];
        const { respCode, data = {}, respMsg } = await createWalletApi.getQdbContractPreview({ partnerId });

        if (respCode !== STATUS.SUCCESS) throw new Error(respMsg);

        const { qualificationName, todayDate } = data;

        this.qualificationName = qualificationName;
        this.signDate = todayDate;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pb-qdb {
  padding: 10px;
  font-size: 14px;
  &__bold {
    font-weight: bold;
  }
  &__center {
    text-align: center;
  }
  &__under-line {
    text-decoration:underline;
  }
  ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 20px;
    li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
  }
}
</style>
